<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    icon: string,
    to?: RouteLocationRaw,
    count?: number,
    countTitle?: string,
  }>()
</script>

<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    class="sidebar-item">
    <fa-icon
      class="sidebar-item-icon"
      :icon="icon" />
    <div class="flex-1 whitespace-nowrap">
      <slot></slot>
    </div>
  </component>
</template>

<style lang="postcss" scoped>
  .sidebar-item {
    @apply block flex w-full h-7 mb-2 items-center items-center space-x-4 rounded px-px text-left;

    &:hover {
      @apply text-primary-500;
    }
    &.router-link-active {
      @apply text-primary-500 font-bold;
    }
  }

  .sidebar-item-icon {
    @apply flex-shrink-0;
  }
</style>
